'use client';

import { FC } from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';

interface PlayGameLayoutProps {
  chat: React.ReactNode;
  game: React.ReactNode;
  superstars: React.ReactNode;
  video: React.ReactNode;
}

export const PlayGameLayout: FC<PlayGameLayoutProps> = ({
  chat,
  game,
  superstars,
  video,
}) => {
  const isAuthenticated = useIsAuthenticated();
  return (
    <div className="p-0 pt-5 xl:pt-[30px] 2xl:pt-[30px]">
      <div className="grid grid-cols-12 gap-y-[30px] 2xl:gap-x-[30px]">
        <div className="col-span-12 2xl:overflow-hidden 2xl:rounded-xl">
          <div className="grid grid-cols-12 gap-y-[30px] 2xl:h-[calc(100vh-100px)] 2xl:gap-x-0">
            <div className="3xl:col-span-7 order-2 col-span-12 overflow-hidden rounded-xl 2xl:order-1 2xl:col-span-6 2xl:rounded-none">
              {chat}
            </div>
            <div className="3xl:col-span-5 order-1 col-span-12 overflow-hidden rounded-xl 2xl:order-2 2xl:col-span-6 2xl:rounded-none">
              {game}
            </div>
          </div>
        </div>
        {superstars && (
          <div
            className={cn('col-span-12', {
              '3xl:col-span-7 2xl:col-span-6': video != null && isAuthenticated,
            })}
          >
            {superstars}
          </div>
        )}
        {video && (
          <div className="3xl:col-span-5 col-span-12 2xl:col-span-6">
            {video}
          </div>
        )}
      </div>
    </div>
  );
};
